import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTime from "@mui/icons-material/AccessTime";
import color from "../utils/Colors";

interface Lesson {
  title: string;
  lessonNumber: string;
  lessonTime: string;
}

interface CourseCardProps {
  courseNumber: string;
  courseTitle: string;
  lessons: Lesson[];
}

const CourseChapterCard: React.FC<CourseCardProps> = ({
  courseNumber,
  courseTitle,
  lessons,
}) => {
  return (
    <Box
      sx={{
        background: color.secondColor,
        display: "flex",
        flexDirection: "column",
        boxShadow: "10px 20px 20px rgba(0, 0, 0, 0.04)",

        borderRadius: "4px",
        p: 3,
        pb: 4,
      }}
    >
      <Typography
        sx={{
          color: color.textColor,
          fontWeight: "600",
          fontSize: { xs: "18px", sm: "20px", md: "38px" },
          padding: "20px",
          pb: "10px",
          pl: 0,
          textAlign: "right",
        }}
      >
        {courseNumber}
      </Typography>

      <Typography
        sx={{
          color: color.textColor,
          fontWeight: "600",
          mb: 1,
        }}
      >
        {courseTitle}
      </Typography>

      {lessons.map((lesson, index) => (
        <Box
          key={index}
          sx={{
            p: 2,
            pt: 1,
            pb: 1,
            mt: 2,
            mb: 1,
            borderRadius: "4px",
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            border: "solid 1px",
            borderColor: color.borderColor,
            background: "white",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: color.textColor,
                fontWeight: "600",
              }}
            >
              {lesson.title}
            </Typography>
            <Typography
              sx={{
                color: "grey",
              }}
            >
              {lesson.lessonNumber}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 1,
              height: "fit-content",
              borderRadius: "4px",
              background: color.secondColor,
              gap: "5px",
            }}
          >
            <AccessTime />
            <Typography
              sx={{
                display: "flex",
                width: "88px",
                flexWrap: "wrap",
                // width: "fit-content",
              }}
            >
              {" "}
              {lesson.lessonTime}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CourseChapterCard;
